export default {"src":"/_next/static/media/INCY.a2317599.svg","height":18,"width":18};